import * as React from "react";
import { HelpCards, HelpDialog, HelpDialogProps } from "@/containers/Coach/DesignStudio/help/HelpDialog";

const STEPS = [
  { title: "Pick a review", body: "Any review that's ready to share. Your best one is already chosen for you." },
  {
    title: "Pick a look",
    body: "Designs your marketing team approved. Your name, photo, and branding are added for you.",
  },
  { title: "Post it", body: "Check the caption, choose where it goes, and post now or schedule it." },
];

export const PersonalizedPostsHelpDialog: React.FC<HelpDialogProps> = ({ open, onOpenChange }) => (
  <HelpDialog
    open={open}
    onOpenChange={onOpenChange}
    title="How personalized posts work"
    description="Your review, your name and photo, your branding. Ready to share in under a minute."
    footer={null}
  >
    <HelpCards items={STEPS} columns={3} numbered />
    <p className="text-sm text-slate-600">
      Nothing to design. The look is set by your team, and every post comes out on brand.
    </p>
  </HelpDialog>
);
